import React, { Component } from 'react';
import { Field } from 'react-final-form';
import { Form } from 'antd';
import Translate from 'react-translate-component';
import cx from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import { path } from 'ramda';

import { SALARY_MASK } from 'constants/regexp';
import Select from 'components/common/form/Select';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import InputNumberMask from 'components/common/form/InputNumberMask';
import { SelectLoadComponent } from 'components/common/form/Select';
import DatePicker from 'components/common/form/DatePicker';
import Input from 'components/common/form/Input';
import { formItemLayout } from 'constants/formItemLayout';
import { currency } from 'constants/dictionaries';
import { isProbationState, isEmployeedState, isExcludedState, hasWhoTrudo } from 'helpers/personHelper';
import { DATE_FORMATS } from 'constants/dateFormats';
import { DEFAULT_PROBATION } from 'constants/events';
import { formatMoney } from 'helpers/fieldsHelpers';

export const onChangeStage = (props, stage) => {
    const isHasWhoTrudo = hasWhoTrudo(props.params.projectTypeId);
    const isProbation = isProbationState(stage);
    const isEmployed = isEmployeedState(stage);

    if (isProbation || isEmployed) {
        props.form.change('come_to_work_date', moment().format(DATE_FORMATS.format));

        if (isHasWhoTrudo) {
            const user = (props.params.participators || []).find(participator => participator.id === props.user.id);
            props.form.change('whoTrudoId', props.whoId || user ? props.user.id : path([0, 'id'], props.participators));
        }
    } else {
        isHasWhoTrudo && props.form.change('whoTrudoId', null);
    }

    if (isProbation) {
        const probation = props.params.probation || DEFAULT_PROBATION;
        props.form.change('endOfTrial', moment().add(probation, 'days').format(DATE_FORMATS.format));
    }
};

@withAutoFocusForm
export default class PersonStateFields extends Component {
    static propTypes = {
        menu: PropTypes.array,
        participators: PropTypes.array,
        values: PropTypes.object.isRequired,
        form: PropTypes.object.isRequired,
        params: PropTypes.object.isRequired,
        dictionaryAction: PropTypes.object.isRequired,
        resetPersonState: PropTypes.func.isRequired,
    };

    onChangeStage = stage => {
        onChangeStage(this.props, stage);
        this.props.resetPersonState();
    }

    render() {
        const { menu, participators, values, dictionaryAction, params } = this.props;
        const isHasWhoTrudo = hasWhoTrudo(params.projectTypeId);
        const isProbation = isProbationState(values.idm);
        const isEmployed = isEmployeedState(values.idm);
        const isExcluded = isExcludedState(values.idm);
        const notEmployeed = !isEmployed && !isProbation;

        return (
            <div>
                <Field
                    name='idm'
                    component={Select}
                    onChangeTransformer={value => +value}
                    onChange={this.onChangeStage}
                    placeholder={<Translate content='placeholders.personState' />}
                    options={menu}
                    valuePath='idm'
                    label={{
                        content: 'events.state',
                        required: true
                    }}
                    dictionaryAction={dictionaryAction}
                />
                <Field
                    name='come_to_work_date'
                    component={DatePicker}
                    hidden={notEmployeed}
                    label={{
                        content: 'events.startWorking',
                        required: true
                    }}
                />
                <Field
                    name='endOfTrial'
                    component={DatePicker}
                    hidden={!isProbation}
                    label={{
                        content: 'events.endOfProbation',
                        required: true
                    }}
                />
                <Form.Item
                    className={cx({ 'hide': notEmployeed })}
                    label={!notEmployeed && <Translate content='events.salary' />}
                    {...formItemLayout}
                    required={true}
                >
                    <Field name='salary'
                        component={InputNumberMask}
                        placeholder='placeholders.salary'
                        notWrap={true}
                        containerClass="inline"
                        className="amount-from"
                        step="1000"
                        hidden={notEmployeed}
                        mask={SALARY_MASK}
                        formatter={formatMoney}
                    />
                    <Field name='salaryCurrency'
                        component={SelectLoadComponent}
                        loadName={currency}
                        namePath='code'
                        placeholder={<Translate content='placeholders.currency' />}
                        notWrap={true}
                        containerClass="inline"
                        style={{width: '100px'}}
                        allowClear
                        hidden={notEmployeed}
                        notError={true}
                    />
                </Form.Item>
                <Form.Item
                    className={cx({ 'hide': notEmployeed })}
                    label={!notEmployeed && <Translate content='events.gonorar' />}
                    {...formItemLayout}
                >
                    <Field name='fee'
                        component={InputNumberMask}
                        placeholder='placeholders.fee'
                        notWrap={true}
                        containerClass="inline"
                        className="amount-from"
                        step="1000"
                        hidden={notEmployeed}
                        mask={SALARY_MASK}
                        formatter={formatMoney}
                    />
                    <Field name='feeCurrency'
                        component={SelectLoadComponent}
                        loadName={currency}
                        namePath='code'
                        placeholder={<Translate content='placeholders.currency' />}
                        notWrap={true}
                        containerClass="inline"
                        style={{width: '100px'}}
                        hidden={notEmployeed}
                        allowClear
                    />
                </Form.Item>
                <Field
                    name='position'
                    component={Input}
                    label={{ content: 'events.positionName', required: true }}
                    placeholder={'placeholders.enterPosition'}
                    hidden={notEmployeed}
                />
                <Field
                    name='whoTrudoId'
                    component={Select}
                    placeholder={<Translate content='placeholders.chooseEmployee' />}
                    options={participators}
                    namePath='text'
                    label={{
                        content: 'events.whoTrudo',
                        required: true
                    }}
                    hidden={notEmployeed || !isHasWhoTrudo}
                />
               <Field
                    name='comment'
                    component={Input}
                    label={{ content: 'events.comment', required: isExcluded }}
                    hidden={notEmployeed && !isExcluded}
                    placeholder={'placeholders.comment'}
                />
            </div>
        );
    }
}
